<template>
  <!--
    Komponent wyświetlający warstwę filtru rozdzielczości (statResolutionValue i statResolutionUnit).
    Pokazuje wartość i jednostkę rozdzielczości z możliwością usunięcia filtru.
  -->
  <div
    v-if="store.filters.statResolutionUnit || store.filters.statResolutionValue"
    class="filter d-flex flex-column"
  >
    <!--
      Nagłówek sekcji: tłumaczenie klucza 'resolution', przycisk usuwający filtr.
      Icon-trash usuwa filtr po kliknięciu.
    -->
    <h5 class="margin-0">
      {{ t('resolution') }}
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <!--
      Sekcja z informacją o aktualnie ustawionej rozdzielczości.
      Warunki:
        - Jeśli statResolutionValue == 10: wyświetl tekst z store.resolution na podstawie statResolutionUnit.
        - W przeciwnym razie: wyświetl wartość statResolutionValue wraz z jednostką z store.resolution.
    -->
    <div class="info collapse show" id="resolutionFilterView">
      <p v-if="store.filters.statResolutionValue == 10" class="margin-0">
        {{ store.resolution[store.filters.statResolutionUnit] }}
      </p>
      <p v-else-if="store.filters.statResolutionValue" class="margin-0">
        {{ store.filters.statResolutionValue }}
        {{ store.resolution[store.filters.statResolutionUnit] }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResolutionFilterView",  // Nazwa komponentu Vue
  props: {
    // Wymagany store zawierający filtry i mapowanie jednostek rozdzielczości
    store: { required: true },
  },
  methods: {
    /**
     * Usuwa filtr rozdzielczości (usunie pola statResolutionUnit i statResolutionValue ze store.filters)
     */
    removeFilter() {
      this.store.removeItem("resolution");
    },
  },
};
</script>

<style scoped>
.filter {
  width: 100%; /* Filtr zajmuje całą szerokość kontenera */
}

.filter h5 {
  margin: 0;
  padding: var(--spacing-md) var(--spacing-lg);
  position: relative;
  background: var(--surface-secondary);
  border-bottom: 1px solid var(--border-default);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  letter-spacing: var(--letter-spacing-caps);
  text-transform: uppercase;
  color: var(--text-primary);
}

/*
  Sekcja informacyjna pod nagłówkiem:
    - font-size: 12px
    - padding: 12px wewnątrz
    - dolna granica obszaru
*/
.info {
  font-size: var(--font-size-sm);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
}

.info p {
  font-size: var(--font-size-sm); /* Styl paragrafu z wartością filtru */
}

/* Ikonka kosza do usuwania filtra */
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 8px;
  right: 10px;
}

/* Styl ikonki rozwijania/zwijania (skomentowane w template) */
.icon-collapse {
  background: url("../../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 20px;
}
.collapsed.icon-collapse {
  background: url("../../assets/icons/rozwin.png") no-repeat left top;
}
</style>
